import React from 'react';

const CommonImageRadio = ({
    name,
    id,
    value,
    label,
    image,
    onChange,
    checked,
    disabled = false,
    errors = {},
    className = '',
    imageClassName = 'img-fluid mb-2',
    labelClassName = 'fs-12-text mb-2',
    containerClassName = 'd-block p-3 border rounded shadow-sm h-100 align-items-center text-center position-relative',
    tickContainerClassName = 'tick_container',
    tickClassName = 'tick'
}) => {
    const error = errors[name];

    return (
        <div className={`${className}`}>
            <input
                type="radio"
                name={name}
                id={id}
                className="d-none imgbgchk"
                value={value}
                onChange={onChange}
                checked={checked}
                disabled={disabled}
            />
            <label 
                className={containerClassName} 
                htmlFor={id}
            >
                {image && (
                    <img 
                        src={image} 
                        alt={label} 
                        className={imageClassName}
                    />
                )}
                {label && (
                    <div className={labelClassName}>{label}</div>
                )}
                <div className={tickContainerClassName}>
                    <div className={tickClassName}>
                        <i className="fa fa-check"></i>
                    </div>
                </div>
            </label>
            {error && (
                <div className="invalid-feedback d-block">
                    {error}
                </div>
            )}
        </div>
    );
};

export default CommonImageRadio; 